import { render, staticRenderFns } from "./SettingSendSign.vue?vue&type=template&id=87d39a3e&scoped=true"
import script from "./SettingSendSign.vue?vue&type=script&lang=js"
export * from "./SettingSendSign.vue?vue&type=script&lang=js"
import style0 from "./SettingSendSign.vue?vue&type=style&index=0&id=87d39a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d39a3e",
  null
  
)

export default component.exports